import { SamlIdpTranslator } from 'src/translators'
import { SamlIdpEntity, SamlIdpFormEntity } from 'src/types'
import {
  useCreateSamlIdpMutation,
  useUpdateSamlIdpMutation,
  useDeleteSamlIdpMutation,
} from 'src/types/generated'

export const useSamlIdp = () => {
  const [createSamlIdpMutation] = useCreateSamlIdpMutation()
  const [updateSamlIdpMutation] = useUpdateSamlIdpMutation()
  const [deleteSamlIdpMutation] = useDeleteSamlIdpMutation()

  const createSamlIdp = async (companyId: number, formEntity: SamlIdpFormEntity): Promise<void> => {
    const input = SamlIdpTranslator.toSamlIdpRequest(formEntity)
    await createSamlIdpMutation({ variables: { companyId, params: input } })
  }

  const updateSamlIdp = async (
    companyId: number,
    identityProviderId: number,
    formEntity: SamlIdpFormEntity
  ): Promise<void> => {
    const input = SamlIdpTranslator.toSamlIdpRequest(formEntity)
    await updateSamlIdpMutation({ variables: { companyId, identityProviderId, params: input } })
  }

  const deleteSamlIdp = async (companyId: number, identityProviderId: number): Promise<void> => {
    await deleteSamlIdpMutation({ variables: { companyId, identityProviderId } })
  }

  const toFormEntity = (entity: SamlIdpEntity): SamlIdpFormEntity => {
    return SamlIdpTranslator.toFormEntity(entity)
  }

  return {
    createSamlIdp,
    updateSamlIdp,
    deleteSamlIdp,
    toFormEntity,
  }
}
